exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper-frame[data-v-44ae3c92]{width:100%;padding:25px;margin-bottom:15px\n}\n.network>.md-layout[data-v-44ae3c92],.channel>.md-layout[data-v-44ae3c92]{overflow:hidden;max-width:100%\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-44ae3c92","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/ContentTargetsForm.vue
// module id = 196
// module chunks = 0